/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cerez_S7_HeadingInputs */

const tr_cerez_s7_heading = /** @type {(inputs: Cerez_S7_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`7. İlgili Metinler`)
};

const en_cerez_s7_heading = /** @type {(inputs: Cerez_S7_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`7. Related texts`)
};

const de_cerez_s7_heading = /** @type {(inputs: Cerez_S7_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`7. Zugehörige Texte`)
};

const ru_cerez_s7_heading = /** @type {(inputs: Cerez_S7_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`7. Связанные тексты`)
};

/**
* | output |
* | --- |
* | "7. Related texts" |
*
* @param {Cerez_S7_HeadingInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const cerez_s7_heading = /** @type {((inputs?: Cerez_S7_HeadingInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cerez_S7_HeadingInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cerez_s7_heading(inputs)
	if (locale === "de") return de_cerez_s7_heading(inputs)
	if (locale === "ru") return ru_cerez_s7_heading(inputs)
	return tr_cerez_s7_heading(inputs)
});